import React from "react";
import styled from "styled-components";

/**
 * Scrollable features list.
 * Parent gives this component flex-grow space. We scroll internally.
 */
function FeaturesList({ features = [], lang = "th" }) {
  const empty = !Array.isArray(features) || features.length === 0;

  return (
    <Wrapper>
      <SectionLabel>{lang === "en" ? "FEATURES" : "สิ่งที่ได้"}</SectionLabel>

      <ListBox>
        {empty ? (
          <EmptyState>—</EmptyState>
        ) : (
          features.map((feature, idx) => (
            <Item key={idx}>
              <Check aria-hidden>✓</Check>
              <Text>{feature}</Text>
            </Item>
          ))
        )}
      </ListBox>
    </Wrapper>
  );
}

export default React.memo(FeaturesList);

// ─── Styled ──────────────────────────────────

const Wrapper = styled.div`
  padding: 0 16px 8px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const SectionLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`;

const ListBox = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 4px;
  background: #f9fafb;
  border-radius: 8px;

  /* Slim scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #374151;
`;

const Check = styled.span`
  color: #10b981;
  margin-right: 8px;
  flex-shrink: 0;
  font-weight: 700;
`;

const Text = styled.span`
  word-break: break-word;
`;

const EmptyState = styled.div`
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  padding: 16px;
`;